module.exports = __webpack_public_path__ + "media/INTCGM1.b932053d.mp4";